export default {
    name: "interactiveText",
    title: "Interactive Text",
    icon: require("./content-icon.svg"),
    category: "training"
}